package com.hyperether.goodjob

import kotlinx.browser.window


class PlatformCheckerJs : PlatformChecker {

    //todo  this is not good, we need to check if it is web platform and in separate check if it is browser on mobile
    override fun isMobile(): Boolean {
        return false
    }

    override fun isMobileWebView(): Boolean {
        val userAgent = js("navigator.userAgent") as String
//        log.d("isWebMobileView: ") { "isMobileWebView: $isMobileWebView window.innerWidth: ${window.innerWidth}" }
        return userAgent.contains("Mobi") || userAgent.contains("Android") || window.innerWidth <= 980
    }
}

actual fun getPlatformChecker(): PlatformChecker {
    return PlatformCheckerJs()
}

actual fun reloadWindowCmp() {
    reloadWindow()
}

actual fun clearInputCmp() {
    clearInput()
}

@JsName("clearInput")
external fun clearInput()

@JsName("reloadWindow")
external fun reloadWindow()



